import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import deleteIcon from '../../../../../assets/svgs/delete-icon.svg';
import messageIcon from '../../../../../assets/svgs/message-icon.svg';
import { CustomIcon } from '../../../../../components/widgets/CustomIcon';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { NotificationTable } from '../components/NotificationTable';
import { useNotificationContext } from '../context/NotificationContext';
import { NotificationLayout } from '../layouts/NotificationLayout';
import { NotificationType_ } from '../types/notificationTypes';

const apiNotificacoes = apiSensedia;

// if (process.env.NODE_ENV != 'development') {
//   apiNotificacoes = apiSensedia;
// }

export const Notificacoes = () => {
  const navigate = useNavigate();

  const {
    status,
    notificationsFiltered,
    setNotificationsFiltered,
    selectedItems,
    setSelectedItems,
    resetCheckboxes,
    currentPage,
    itemsPerPage,
    offset
  } = useNotificationContext();

  const [notifications, setNotifications] = useState<NotificationType_[]>([]);
  const [totalNotifications, setTotalNotifications] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getNotifications = async (offset: number, limit: number) => {
    setIsLoading(true);
    const isFilterSet = status === 'Lida' || status === 'Não lida';

    try {
      const response = await apiNotificacoes.get(
        `/notificacoes/notificacoes-tela?${
          isFilterSet ? `&lida=${status === 'Lida'}` : ''
        }&_limit=${limit}&_offset=${offset}`
      );

      setNotifications(response.data._embedded._result);
      setNotificationsFiltered(response.data._embedded._result);
      setTotalNotifications(response.data._embedded._total);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const deleteMultipleNotifications = async (ids: unknown[]) => {
    setIsLoading(true);
    const joinedIDs = ids.join(',');

    try {
      await apiNotificacoes.delete(
        `notificacoes/notificacoes-tela?ids=${joinedIDs}`
      );

      const updatedNotifications = notifications.filter(
        (item) => !ids.includes(item.id)
      );

      setNotificationsFiltered(updatedNotifications);
      getNotifications(offset - 1, itemsPerPage);
      setSelectedItems(new Set());
      resetCheckboxes();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const upDateMultipleNotifications = async (ids: unknown[]) => {
    const updateData = {
      ids: ids
    };

    try {
      const response = await apiSensedia.patch(
        'notificacoes/notificacoes-tela',
        updateData
      );

      getNotifications(offset - 1, itemsPerPage);
      setSelectedItems(new Set());
      resetCheckboxes();
    } catch (error) {
      console.log(error);
    }
  };

  const buttonsMobile = [
    {
      icon: (
        <CustomIcon src={messageIcon} width={18} height={16} color="#146CFA" />
      ),
      label: 'Marcar todas como lida',
      border: '#146CFA',
      action: upDateMultipleNotifications,
      disable: notificationsFiltered.length === 0
    },
    {
      icon: (
        <CustomIcon src={deleteIcon} width={21} height={19} color="#AA2C23" />
      ),
      label: 'Excluir mensagens',
      border: '#AA2C23',
      action: deleteMultipleNotifications,
      disable: selectedItems.size === 0
    },
    {
      icon: <CustomIcon src={''} />,
      label: 'Voltar',
      border: '#001E64',
      action: () => navigate(-1),
      disable: false
    }
  ];

  const headersIcons = [
    {
      icon: messageIcon,
      tolltip: 'Marcar como lida',
      action: upDateMultipleNotifications
    },
    {
      icon: deleteIcon,
      tolltip: 'Deletar notificação',
      action: deleteMultipleNotifications
    }
  ];

  useEffect(() => {
    getNotifications(offset - 1, itemsPerPage);
  }, [currentPage, itemsPerPage, status]);

  return (
    <NotificationLayout title="Todas as notificações">
      <NotificationTable
        isLoading={isLoading}
        data={notifications}
        totalData={totalNotifications}
        headersIcons={headersIcons}
        buttonsMobile={buttonsMobile}
      />
    </NotificationLayout>
  );
};
